import { render, staticRenderFns } from "./modifyInfoDialog.vue?vue&type=template&id=b736b8e0&scoped=true"
import script from "./modifyInfoDialog.vue?vue&type=script&lang=js"
export * from "./modifyInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./modifyInfoDialog.vue?vue&type=style&index=0&id=b736b8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b736b8e0",
  null
  
)

export default component.exports